import React from "react";
import ShopCreate from "../components/Shop/ShopCreate.jsx";

const ShopCreatePage = () => {
  return (
    <div>
      <ShopCreate />
    </div>
  );
};

export default ShopCreatePage;
